import axios from "axios";
const api = axios.create({
    baseURL : 'https://makeeasyway.in/jobSiteData/',  
    // baseURL : 'http://localhost/jobSiteData/',


    header: {
        'Content-Type' : 'application/json'
    }
});
api.interceptors.response.use(
    (response)=>{
        return response;
    },
    (error)=>{
     if(error.response){
        console.error("Api error" , error.response.data)
     }else if(error.request){
        console.error('network error', error.message)
     }else{
        console.error("request setup error ", error.request.message)
     }   
     return Promise.reject(error);
    }
);
export default api;